<script>
export default {
    props: {
        containerClass: {
            type: String,
            default: null
        },
    }
}
</script>

<template>
    <div class="cell shrink">
        <div @click="() => $emit('click')" class="add-button pt-23">
            <i class="fas fa-plus-circle"></i>
        </div>
    </div>
</template>

<style>
.add-button {
    opacity: 1;
}
</style>